module.exports = __webpack_public_path__ + "img/device-2-1024x986.2dfa7c92.png";